export const formatCityStateCountry = (address) => {
  if (!address) return "";
  const locality = address.city || address.lga || "";
  return [locality, address.state, address.country]
    .map((part) => (part ? `${part}`.trim() : ""))
    .filter(Boolean)
    .join(", ");
};
